import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Clock, Phone, ArrowRight } from 'lucide-react';
const CLEANING_IMAGES = ['https://cdn.magicpatterns.com/uploads/1qhsuwr7sDWPWa5zUYWfL5/vella-staff-cleaning-livingroom-1024x683.jpg', 'https://cdn.magicpatterns.com/uploads/8yFUbyT5XW7AfLAedWXq6Z/young-cleaner-washing-floor-in-open-space-office.jpg', 'https://cdn.magicpatterns.com/uploads/upGzpcuHN7UebJynv3SRFy/high-class-office-cleaning.jpg' // High class office cleaning
];
export function Hero() {
  return <section id="home" className="relative pt-28 pb-16 lg:pt-36 lg:pb-24 overflow-hidden bg-gradient-to-b from-teal-50/50 to-white" data-id="element-160">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%230d9488' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }} data-id="element-161" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-162">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-163">
          {/* Text Content */}
          <div className="lg:w-1/2 text-center lg:text-left" data-id="element-164">
            {/* Trust Badge */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="inline-flex items-center gap-2 bg-white border border-teal-100 rounded-full px-4 py-1.5 shadow-sm mb-6" data-id="element-165">
              <div className="flex gap-0.5" data-id="element-166">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-167" />)}
              </div>
              <span className="text-sm font-medium text-gray-600" data-id="element-168">
                #1 Rated in Glasgow
              </span>
            </motion.div>

            {/* Headline */}
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-[1.1] mb-6 tracking-tight" data-id="element-169">
              Five-Star Rated{' '}
              <span className="text-teal-600" data-id="element-170">Cleaning Services</span> in
              Glasgow
            </motion.h1>

            {/* Subheadline */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-171">
              Reliable, professional cleaning for homes & businesses you can
              trust. Fully insured, vetted staff, and 100% satisfaction
              guaranteed.
            </motion.p>

            {/* CTAs */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="flex flex-col sm:flex-row items-center lg:items-start justify-center lg:justify-start gap-4 mb-10" data-id="element-172">
              <a href="#contact" className="w-full sm:w-auto bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-xl shadow-teal-600/20 hover:shadow-teal-600/40 transform hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-173">
                Get a Free Quote
                <ArrowRight className="w-5 h-5" data-id="element-174" />
              </a>
              <a href="tel:07355854313" className="w-full sm:w-auto bg-white hover:bg-gray-50 text-gray-800 border-2 border-gray-200 hover:border-teal-200 px-8 py-4 rounded-full font-bold text-lg transition-all flex items-center justify-center gap-2" data-id="element-175">
                <Phone className="w-5 h-5 text-teal-600" data-id="element-176" />
                Call 07355 854313
              </a>
            </motion.div>

            {/* Trust Indicators */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="flex flex-wrap items-center justify-center lg:justify-start gap-6 pt-6 border-t border-gray-100" data-id="element-177">
              <div className="flex items-center gap-2" data-id="element-178">
                <ShieldCheck className="w-5 h-5 text-teal-600" data-id="element-179" />
                <span className="text-sm font-medium text-gray-700" data-id="element-180">
                  Fully Insured
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-181">
                <Clock className="w-5 h-5 text-teal-600" data-id="element-182" />
                <span className="text-sm font-medium text-gray-700" data-id="element-183">
                  Reliable Service
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-184">
                <Star className="w-5 h-5 text-teal-600" data-id="element-185" />
                <span className="text-sm font-medium text-gray-700" data-id="element-186">
                  5-Star Rated
                </span>
              </div>
            </motion.div>
          </div>

          {/* Image Grid */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:w-1/2 relative" data-id="element-187">
            <div className="grid grid-cols-2 gap-4" data-id="element-188">
              {/* Main large image */}
              <div className="col-span-2 relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-189">
                <img src={CLEANING_IMAGES[0]} alt="Professional cleaning service" className="w-full h-64 md:h-80 object-cover" data-id="element-190" />
                <div className="absolute inset-0 bg-gradient-to-t from-teal-900/20 to-transparent" data-id="element-191" />
              </div>
              {/* Two smaller images */}
              <div className="relative rounded-xl overflow-hidden shadow-lg" data-id="element-192">
                <img src={CLEANING_IMAGES[1]} alt="Clean modern interior" className="w-full h-32 md:h-40 object-cover" data-id="element-193" />
              </div>
              <div className="relative rounded-xl overflow-hidden shadow-lg" data-id="element-194">
                <img src={CLEANING_IMAGES[2]} alt="Sparkling clean kitchen" className="w-full h-32 md:h-40 object-cover" data-id="element-195" />
              </div>
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-4 -left-4 bg-white rounded-xl shadow-xl p-4 border border-gray-100" data-id="element-196">
              <div className="flex items-center gap-3" data-id="element-197">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center" data-id="element-198">
                  <span className="text-white font-bold text-lg" data-id="element-199">10+</span>
                </div>
                <div data-id="element-200">
                  <div className="font-bold text-gray-900" data-id="element-201">Years</div>
                  <div className="text-xs text-gray-500" data-id="element-202">Experience</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}